import styled from "styled-components/macro";
import {DefaultFont} from "../../../styles/fonts";

export const TeamSection = styled.div`
`;

export const JobSection = styled.div`
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: wrap;
  gap: 2em;
  align-items: center;
  justify-items: center;
  margin-top: 8em;
  
  .image {
    max-width: 50em;
    min-width: 20em;
    width: auto;
    height: auto;
    border-radius: 8px;
    flex: 1 1 38%;
    @media ${(props) => props.theme.media.phone} {
      flex-grow: 999;
    }
  }
  
  & > div{
    flex: 1 1 38%;
  }

  @media ${(props) => props.theme.media.phone} {
    margin-top: 3em;
  }
`;

export const SectionHeader = styled.div`
  ${DefaultFont};
  color: ${(props) => props.theme.text.color.orange};
  margin-bottom: 0.7em;
`;

export const Members = styled.div`
  
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  gap: 2rem;
  margin:0px auto;
  margin-top: 5em;

  svg {
    vertical-align: middle;
    width: 2em;
  }
  
  .image {
    width: 100%;
    min-width: 18em;
    max-width: 50em;
    display: block;
    object-fit: contain;
    border-radius: 8px;
    margin-bottom: 1em;
  }
  
  h1 {
    ${DefaultFont};
    font-weight: 600;
    margin-bottom: 0.2em;
    @media ${(props) => props.theme.media.phone} {
      font-weight: 600;
    }
  }

  h2 {
    ${DefaultFont};
    color: ${(props) => props.theme.text.color.orange};
  }

  h3 {
    ${DefaultFont};
    color: ${(props) => props.theme.text.color.blueDimmed};
    font-size: 18px;
    @media ${(props) => props.theme.media.phone} {
      font-size: 16px;
    }
  }
  
  p {
    font-size: 18px;
    @media ${(props) => props.theme.media.phone} {
      font-size: 16px;
    }
  }
  
  & > div {
    height: 100%;
    width: fit-content;
    flex: 0 0 30%;
    @media ${(props) => props.theme.media.phone} {
      flex-grow: 999;
    }
  }
  
`;
